<template>
  <div class="footerNavigation" v-if="!isNavbarVisible">
    <div class="tabbedNavigation">
      <tabbed-navigation />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TabbedNavigation from './tabbedNavigation';

export default {
  name: 'MainNavigation',
  components: {
    TabbedNavigation
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['device']),
    isNavbarVisible() {
      // If we are on the devicelist route and have not yet chosen a device,
      // we have to hide this component. A user must first select a device in
      // order to navigate to different routes.
      return this.$route.name === 'devicelist' && !(this.device || {}).serial;
    }
  }
};
</script>

<style lang="scss" scoped>
.footerNavigation {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 48px;
  background: white;
  box-shadow: 0 -2px 8px 0 rgba(60, 70, 75, 0.2);
  z-index: 5;
  display: block;

  .tabbedNavigation {
    margin: 0 auto;
  }

  @include breakpoint(sm) {
    display: none;
  }
}
</style>
